import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  GlobalSettingsState,
  GlobalSetting,
  GlobalSettingsListData,
} from '../../types/globalSettings.types';

const initialState: GlobalSettingsState = {
  settings: [],
  selectedSetting: null,
  loading: false,
  error: null,
  pagination: {
    page: 1,
    pageSize: 10,
    totalPages: 0,
    totalRecords: 0,
    hasMorePages: false,
  },
  search: '',
};

const globalSettingsSlice = createSlice({
  name: 'globalSettings',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setSettings: (state, action: PayloadAction<GlobalSettingsListData>) => {
      state.settings = action.payload.settings;
      state.pagination = {
        ...state.pagination,
        totalPages: action.payload.totalPages,
        totalRecords: action.payload.totalRecords,
        hasMorePages: action.payload.hasMorePages,
      };
      state.loading = false;
      state.error = null;
    },
    setSelectedSetting: (state, action: PayloadAction<GlobalSetting | null>) => {
      state.selectedSetting = action.payload;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.pagination.page = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pagination.pageSize = action.payload;
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
      // Reset to page 1 when searching
      state.pagination.page = 1;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearSelectedSetting: (state) => {
      state.selectedSetting = null;
    },
    updateSetting: (state, action: PayloadAction<GlobalSetting>) => {
      const index = state.settings.findIndex((s) => s.id === action.payload.id);
      if (index !== -1) {
        state.settings[index] = action.payload;
      }
      // También actualizar selectedSetting si coincide
      if (state.selectedSetting?.id === action.payload.id) {
        state.selectedSetting = action.payload;
      }
    },
  },
});

export const {
  setLoading,
  setError,
  setSettings,
  setSelectedSetting,
  setPage,
  setPageSize,
  setSearch,
  clearError,
  clearSelectedSetting,
  updateSetting,
} = globalSettingsSlice.actions;

export default globalSettingsSlice.reducer;
